import { PaymentMethodContext } from "../context/PaymentMethodContext";

export const PaymentMethodProvider = ({ children }) => {
  return (
    <PaymentMethodContext.Provider value={{}}>
      {children}
    </PaymentMethodContext.Provider>
  )
}